import api from './api';

export interface SlideExportResult {
  id: string;
  format: 'html' | 'pdf' | 'pptx';
  slide_count: number;
  generated_at: string;
  download_url: string;
  html?: string;
}

export interface SlideExportHistoryItem {
  id: string;
  format: 'html' | 'pdf' | 'pptx';
  slide_count: number;
  created_at: string;
  created_by: string;
  download_url: string;
}

export interface RegenerateSlideResult {
  markdown: string;
  html: string;
  slide_count: number;
}

export interface GenerateForPhase2Result {
  slide_count: number;
  phase: number;
}

export interface AssembleForPhase4Result {
  replacements: number;
  phase: number;
  message: string;
}

export const slidesService = {
  generateForPhase2: async (
    lessonId: string,
    versionNumber: number,
  ): Promise<GenerateForPhase2Result> => {
    const response = await api.post<GenerateForPhase2Result>(
      `/lessons/${lessonId}/versions/${versionNumber}/slides/generate`,
      {},
      { timeout: 120_000 },
    );
    return response.data;
  },

  export: async (
    lessonId: string,
    versionNumber: number,
    format: 'html' | 'pdf' | 'pptx' = 'html',
    slideNumbers?: number[],
  ): Promise<SlideExportResult> => {
    const response = await api.post<SlideExportResult>(
      `/lessons/${lessonId}/versions/${versionNumber}/slides/export`,
      { format, ...(slideNumbers && slideNumbers.length > 0 ? { slide_numbers: slideNumbers } : {}) },
      { timeout: 75_000 },
    );
    return response.data;
  },

  listExports: async (
    lessonId: string,
    versionNumber: number,
  ): Promise<SlideExportHistoryItem[]> => {
    const response = await api.get<SlideExportHistoryItem[]>(
      `/lessons/${lessonId}/versions/${versionNumber}/slides/exports`,
    );
    return response.data;
  },

  assembleForPhase4: async (
    lessonId: string,
    versionNumber: number,
  ): Promise<AssembleForPhase4Result> => {
    const response = await api.post<AssembleForPhase4Result>(
      `/lessons/${lessonId}/versions/${versionNumber}/slides/assemble-final`,
      {},
    );
    return response.data;
  },

  regenerateSlide: async (
    lessonId: string,
    versionNumber: number,
    currentMarkdown: string,
    slideIndex: number,
    instruction: string,
  ): Promise<RegenerateSlideResult> => {
    const response = await api.post<RegenerateSlideResult>(
      `/lessons/${lessonId}/versions/${versionNumber}/slides/regenerate-slide`,
      { current_markdown: currentMarkdown, slide_index: slideIndex, instruction },
      { timeout: 75_000 },
    );
    return response.data;
  },
};
